<template>
  <div
    v-expose-track="{
      [routerName]: {
        mapId: mapId,
        data: {
          spm: $trackMap[reportModle].goodExpose,
          ssu_id: '',
          price: sku.priceSpm || '',
          ...skuCommonTracerParams
        }
      }
    }"
    class="sku-single"
    @click.stop="goDetail"
  >
    <div class="sku-single-content">
      <sku-img
        :img-url="skuImg.imgUrl"
        :image-width="imgWidth"
        :sku-img="skuImg"
        :bottom-tag="bottomTag"
        :sku-index="skuIndex"
        :rank="rank"
        :show-countdown="showCountdown"
        :remain-time="remainTime"
        :remain-title="remainTitle"
      ></sku-img>
      <div class="sku-wrapper">
        <sku-header :sku="sku"></sku-header>
        <ssu-info
          :ssu="ssu"
          :sku-index="skuIndex"
          :report-modle="reportModle"
          :router-name="routerName"
          :map-id="mapId"
          :common-tracer-param="skuCommonTracerParams"
        ></ssu-info>
      </div>
    </div>
    <ssu-deposit show-deposit :ssu="ssu" single></ssu-deposit>
    <sku-produce-source :sku="sku" single></sku-produce-source>
  </div>
</template>

<script>
import goodMixin from '../goodMixin'
import SsuDeposit from '../ssuDeposit'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  components: {
    SsuDeposit
  },
  mixins: [goodMixin],
  data() {
    return {}
  },
  computed: {
    ssu() {
      return this.sku?.ssuList?.[0]
    }
  },

  created() {},

  methods: {
    goDetail() {
      const ssu = this.ssu
      const params = {
        ssu_id: ssu.ssuId,
        price: this.ssu.priceSpm || '',
        ...ssu.extraTrack
      }
      this.goDetailTrack(params)
      const spm = this.$trackMap[this.reportModle].goodGoDetail
      const tickReferId = `${spm}.${this.skuIndex}`
      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: ssu.ssuId,
        tickReferId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-single {
  padding: 8px 10px 8px 8px;
  box-sizing: border-box;
  .sku-single-content {
    position: relative;
    display: flex;
  }
  .sku-wrapper {
    flex: auto;
    width: 0;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
